// extracted by mini-css-extract-plugin
export default {"ruleNameInput":"RuleNameInput_ruleNameInput__7Fpx-","ruleNameInactive":"RuleNameInput_ruleNameInactive__A3u3I"};